import { render, staticRenderFns } from "./setup-rm-wakeup-sms-modal.vue?vue&type=template&id=4be78289"
import script from "./setup-rm-wakeup-sms-modal.vue?vue&type=script&lang=js"
export * from "./setup-rm-wakeup-sms-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports